import { Injectable } from '@angular/core';

@Injectable()
export class CacheDataService {
    dynamicStructures: any[] = [];
    dynamicDataItems: any[] = [];

    constructor() { }
}